import { render, staticRenderFns } from "./ti1.vue?vue&type=template&id=7be3ab4e&scoped=true&"
import script from "./ti1.vue?vue&type=script&lang=js&"
export * from "./ti1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3ab4e",
  null
  
)

export default component.exports